<div class="content-heading">
  <div class="header-container">
    <h3>Productos Temporales</h3>
    <small>Catálogo de Productos que no se encuentran dentro del sistema de CEQ</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-header">
          <div class="row">
            <div class="col-12 col-md-4">
              <aph-custom-text label="Código" placeholder="Buscar por código..." [(ngModel)]="productCode"
                (ngModelChange)="getProduct()">
              </aph-custom-text>
            </div>
            <div class="col-12 col-md-4">
              <aph-custom-text label="Nombre" placeholder="Buscar por nombre..." [(ngModel)]="productName"
                (ngModelChange)="getProduct()">
              </aph-custom-text>
            </div>
            <div class="ml-auto mr-3 align-self-end">
              <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()"></aph-custom-buttons>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            
            <div class="col-md-12">
              <app-ceq-table #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
                (apiEmitter)="gridEmiter($event)">
              </app-ceq-table>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 col-sm-4 col-md-3">
              <div class="pagesize-control">
                Tama&ntilde;o de p&aacute;gina:
                <select (change)="onPageSizeChange($event.target.value)">
                  <option *ngFor="let size of pageSizes" [ngValue]="size">{{size}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>